module.exports = __webpack_public_path__ + "static/media/Q3_Back_Left.c915ed9c.png";